<template>
  <el-dialog title="复制链接地址" :visible.sync="dialogVisible" width="420px" @close="handleClose" append-to-body>
    <div class="copy-url-dialog-body">
      <el-input type="text" :value="currentUrl" disabled placeholder="暂无链接地址" />
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取 消</el-button>
      <el-button type="primary" @click="handleCopy" :loading="copying"> 复制 </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "CopyUrlDialog",
  data() {
    return {
      copying: false,
      currentUrl: "", // 存储当前URL
      dialogVisible: false
    };
  },
  methods: {
    /**
     * 打开对话框并设置URL
     * @param {String} url - 要复制的链接地址
     */
    open(url = "") {
      this.currentUrl = url;
      this.dialogVisible = true;
    },

    /**
     * 关闭对话框
     */
    close() {
      this.dialogVisible = false;
    },

    async handleCopy() {
      if (!this.currentUrl) {
        this.$message.warning("链接地址不能为空");
        return;
      }

      try {
        this.copying = true;

        // 尝试使用现代浏览器的 Clipboard API
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(this.currentUrl);
        } else {
          // 降级方案：创建临时元素进行复制
          const textarea = document.createElement("textarea");
          textarea.value = this.currentUrl;
          document.body.appendChild(textarea);
          textarea.select();
          document.execCommand("copy");
          document.body.removeChild(textarea);
        }

        this.$message.success("链接已复制到剪贴板");
        this.close(); // 复制成功后关闭对话框
      } catch (err) {
        console.error("复制失败:", err);
        this.$message.error("复制失败，请手动复制");
      } finally {
        this.copying = false;
      }
    },

    handleCancel() {
      this.close();
    },

    handleClose() {
      this.close();
    }
  }
};
</script>

<style scoped>
.copy-url-dialog-body {
  margin-bottom: 10px;
}
</style>
